import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import ChapterLink from 'components/chapter-link/ChapterLink';
import Icon from 'components/icon/Icon';

import { IChapterNavigationList } from 'source/NFR.types';

const ChapterNavigationList: React.FC<IChapterNavigationList> = ({ accordion, link, linkOrLinkList }) => {
  return (
    <Accordion {...accordion}>
      {({ Button, Collapse, isOpen }) => (
        <div className="chapter-navigation-list">
          <div className="chapter-navigation-list--header">
            <Button
              className={cn('chapter-navigation-list--toggle', {
                'chapter-navigation-list--toggle--is-active': isOpen
              })}
            >
              <Icon fill={true} name={'small-arrow-down'} />
            </Button>

            <ChapterLink isHeader={true} {...link} />
          </div>

          <Collapse className="chapter-navigation-list--content">
            <ul className="link-list">
              {linkOrLinkList?.map(({ link, linkOrLinkList }, index) => {
                if (link) {
                  return (
                    <li className="chapter-navigation-list--item" key={link.chapterNumber + String(index)}>
                      <ChapterLink {...link} />
                    </li>
                  );
                }

                if (linkOrLinkList) {
                  return (
                    <li
                      className="chapter-navigation-list--item chapter-navigation-list--item--has-button"
                      key={`${linkOrLinkList.link?.chapterNumber ?? ''}-${index}`}
                    >
                      <ChapterNavigationList {...linkOrLinkList} />
                    </li>
                  );
                }

                return null;
              })}
            </ul>
          </Collapse>
        </div>
      )}
    </Accordion>
  );
};

ChapterNavigationList.displayName = 'ChapterNavigationList';

export default ChapterNavigationList;
